import React from 'react';
import {AssignTerritoriesContainer} from '../../Containers/TerritoryContainer';


const AssignTerritories = (props) => {
	return (
		<AssignTerritoriesContainer />
	);
}

export default AssignTerritories;